import moment from 'moment-timezone';

const timeZoneLima = 'America/Lima';
const dateFormat = 'YYYY-MM-DD';
const dateTimeFormat = 'YYYY-MM-DD HH:mm:ss';

export const fechaInicial = moment().tz(timeZoneLima).startOf('month').format('YYYY-MM-DD hh:mm');
export const fechaFinal = moment().tz(timeZoneLima).endOf('month').format('YYYY-MM-DD hh:mm');
export const fechaActual = moment().tz(timeZoneLima).format('YYYY-MM-DD hh:mm:ss');

export const convertDateInit = (dateInit) => moment(dateInit).format('YYYY-MM-DD 00:00:00');
export const convertDateFinish = (dateFinish) => moment(dateFinish).format('YYYY-MM-DD 23:59:59');

export const getCurrentDateTime = () => moment().tz(timeZoneLima).format(dateTimeFormat);

export const getCurrentDate = (param) => {
    let currentDate;
    if (param) currentDate = moment(param);
    else currentDate = moment();
    return currentDate.tz(timeZoneLima).format(dateFormat);
}
